// Design tokens for the gamification redesign. The layout comes from the
// Claude Design handoff; the colors are mapped onto Bento's existing palette
// (deep-green primary, yellow accent, neutral greys) so the modules blend with
// the rest of the home page.
export const g = {
  // Surfaces
  panelBg: "#fbf9f0",
  cardBg: "#FFFFFF",
  surface2: "#F3F4F6",
  border: "#E5E7EB",
  borderStrong: "#D1D5DC",

  // Primary (deep green — theme primary.main)
  primary: "#014638",
  primaryHover: "#013024",
  primaryTint: "#EAF1EC",
  primaryTintBorder: "#CDE5D4",

  // Success / done
  green50: "#F0FDF4",
  green100: "#DCFCE7",
  greenBorder: "#86EFAC",
  successText: "#016630",

  // Yellow accent (reward / progress)
  yellow: "#F7EE6F",
  yellowBg: "rgba(247, 238, 111, 0.3)",
  yellowBorder: "rgba(247, 238, 111, 0.6)",
  yellowText: "#854D0E",
  yellowBarFrom: "#F2DE3A",
  yellowBarTo: "#E0C01F",

  // Danger / missed
  danger: "#B5482E",
  dangerBg: "#FBE7DF",
  dangerBorder: "#F1C8B8",

  // Purple (legacy onboarding accent — kept for estimate pills)
  purple: "#7C86FF",
  purpleBg: "#EEF2FF",
  purpleText: "#4F39F6",

  // Text
  text: "#101828",
  text2: "#4A5565",
  text3: "#6A7282",
  textDisabled: "#9CA3AF",

  // Progress track
  progressTrack: "#E5E7EB",

  // Radii
  radiusSm: "8px",
  radiusMd: "12px",
  radiusLg: "16px",
  radiusXl: "20px",
} as const;

export const buttonSx = {
  base: {
    textTransform: "uppercase" as const,
    fontWeight: 600,
    fontSize: 13,
    letterSpacing: "0.04em",
    lineHeight: 1.2,
    borderRadius: g.radiusSm,
    px: "18px",
    py: "11px",
    minHeight: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    boxShadow: "none",
  },
  primary: {
    background: g.primary,
    color: "#fff",
    "&:hover": { background: g.primaryHover, boxShadow: "none" },
    "&.Mui-disabled": {
      background: g.surface2,
      color: g.textDisabled,
    },
  },
  ghost: {
    background: "transparent",
    color: g.primary,
    border: `1px solid ${g.borderStrong}`,
    "&:hover": { background: "#fff", borderColor: g.primary },
  },
  danger: {
    background: g.danger,
    color: "#fff",
    "&:hover": { background: "#9c3c25", boxShadow: "none" },
  },
} as const;
